import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Select from './Select';
import useMRFTranslation from 'mrf/utils/useMRFTranslation';

ObjectSelect.propTypes = {
    resource: PropTypes.string.isRequired, // Resource name to save/retrieve data on redux.
    displayAttribute: PropTypes.string.isRequired, // Object display attribute name.
    displayMap: PropTypes.func, // Object display attribute name.
    noneText: PropTypes.string, // Text for the `none` option.
    hideWhenIsEmpty: PropTypes.bool, // Whether or not to hide when list is empty.
};

const defaultEventMapper = e => e.target.value === '' ? null : Number(e.target.value)

export default function ObjectSelect({
    resource: resourceName,
    displayAttribute,
    displayMap,
    noneText = 'None',
    loading,
    hideWhenIsEmpty = false,
    selectEventMapper = defaultEventMapper,
    ...props
}) {
    const resource = useSelector(state => state.resources[resourceName]);
    const  t  = useMRFTranslation();

    // Hide the Select field when the list is empty
    if (hideWhenIsEmpty && resource?.list.length === 0) {
        return null;
    }

    if (!resource?.list) {
        return loading ? loading : <Select disabled {...props}><option value=''>Loading...</option></Select>
    }

    const { list, byId } = resource;

    const objectValue = object => (displayMap
        ? object && displayMap(object)
        : object?.[displayAttribute]
    ) ?? '';

    const options = list.map(id => {
        const o = byId[id];
        return <option key={id} value={o.id}>{t(objectValue(o))}</option>
    });

    return (
        <Select
            eventMapper={selectEventMapper}
            howToRenderMe={value => objectValue(byId?.[value])}
            noneText={noneText}
            {...props}
        >
            {options}
        </Select>
    );
}
